import React from "react";
import ErrorPageSection from "../sections/ErrorPageSection/Content";
const ErrorPage = () => {
  return <ErrorPageSection />;
};

export default ErrorPage;
